import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { SidenavUtils } from '@/common/utils/SideNavUtils';

const adminSideNav = {
  id: 'admin',
  displayName: 'Admin',
  role: 'ADMIN_VIEW',
  icon: fas.faUniversity,
  precedence: 100,
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('admin'),

    // Admin Sections
    { id: 'adminUser', displayName: 'Users', role: 'ADMIN_USER_VIEW', icon: fas.faUser, route: '/admin/user', precedence: 1 },
    { id: 'adminGroup', displayName: 'Groups', role: 'ADMIN_GROUP_VIEW', icon: fas.faUsers, route: '/admin/group', precedence: 2 },
    { id: 'adminRole', displayName: 'Roles', role: 'ADMIN_ROLE_VIEW', icon: fas.faTasksAlt, route: '/admin/role', precedence: 3 },
    { id: 'adminMkt', displayName: 'Marketplaces', role: 'ADMIN_MKT_VIEW', icon: fas.faIndustry, route: '/admin/mkt', precedence: 4 },
    { id: 'adminMachine', displayName: 'Machines', role: 'ADMIN_MACHINE_VIEW', icon: fas.faServer, route: '/admin/machine', precedence: 6 },

    // Add common menus (includes subs, system, and vals)
    ...SidenavUtils.commonMenus('admin', ['subs', 'system', 'vals'])
  ]
};

export default adminSideNav;
